import { useQuery } from "@tanstack/react-query";
import { creativeService } from "../api/services/creativeService";
import type { CreativeUsage } from "../schemas/creativeSchema";

const EMPTY_USAGE: CreativeUsage = {
  playlistCount: 0,
  screenCount: 0,
  playlists: [],
};

/**
 * What deleting these creatives would take with it.
 *
 * Only fetched while a delete is actually pending confirmation — pass null the
 * rest of the time. The counts come back deduplicated across the whole
 * selection, so they are the number of playlists and screens that will
 * actually change, not the number of assignment rows.
 */
export const useCreativeUsage = (ids: string[] | null) => {
  const enabled = !!ids && ids.length > 0;

  const { data, isLoading, error } = useQuery<CreativeUsage, Error>({
    queryKey: ["creative-usage", ids],
    queryFn: () => creativeService.getUsage(ids as string[]),
    enabled,
  });

  return {
    usage: data ?? EMPTY_USAGE,
    isLoading: enabled && isLoading,
    error,
  };
};
